import { Container, Row, Col } from "reactstrap";

// Legal/terms inquiries go to the legal@dejachart.com Google Workspace group
// (forwards to the team).
const EFFECTIVE_DATE = "June 18, 2026";

export default function Terms() {
  return (
    <div style={{ paddingTop: "3rem", paddingBottom: "5rem" }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg="8" md="10">
            <h1 className="page-title">Terms of Service</h1>
            <p style={{ color: "var(--text-muted)", marginBottom: "2.5rem" }}>
              Effective date: {EFFECTIVE_DATE}
            </p>

            <p>
              Welcome to DejaChart. By accessing or using our website and services (collectively,
              the "Service"), you agree to be bound by these Terms of Service ("Terms"). Please read
              them carefully. If you do not agree, do not use the Service.
            </p>

            <h4>1. Acceptance of Terms</h4>
            <p>
              These Terms constitute a legally binding agreement between you and DejaChart
              ("we," "us," or "our"). We reserve the right to update these Terms at any time.
              Your continued use of the Service after changes are posted constitutes your acceptance
              of the revised Terms.
            </p>

            <h4>2. Description of Service</h4>
            <p>
              DejaChart provides AI-powered stock pattern matching and analysis tools. The Service
              analyzes historical price data to identify patterns and generate signals. All content
              on the Service is for informational and educational purposes only.
            </p>

            <h4>3. Not Investment Advice</h4>
            <p>
              <strong>
                Nothing on DejaChart constitutes investment advice, a recommendation to buy or sell
                any security, or a solicitation of any offer to buy or sell any security.
              </strong>{" "}
              Past pattern performance is not a guarantee of future results. Trading involves
              substantial risk of loss. You should consult a licensed financial advisor before
              making any investment decisions.
            </p>

            <h4>4. Eligibility</h4>
            <p>
              You must be at least 18 years old and capable of forming a legally binding contract
              to use the Service. By using the Service, you represent that you meet these requirements.
            </p>

            <h4>5. Account Registration</h4>
            <p>
              You are responsible for maintaining the confidentiality of your account credentials
              and for all activity that occurs under your account. You agree to notify us immediately
              of any unauthorized use of your account.
            </p>

            <h4>6. Subscriptions and Billing</h4>
            <p>
              Certain features require a paid subscription ("Pro"). By subscribing, you authorize
              us to charge your payment method on a recurring basis at the rate shown at checkout.
              Subscriptions renew automatically unless canceled. You may cancel at any time; access
              continues through the end of your current billing period. All fees are non-refundable
              except as required by law.
            </p>
            <p>
              We offer a 14-day free trial for new Pro subscribers. You will not be charged until
              the trial period ends. Cancel before the trial ends to avoid charges.
            </p>

            <h4>7. Intellectual Property</h4>
            <p>
              All content, algorithms, software, data, and materials on the Service are owned by
              DejaChart or its licensors. You may not reproduce, distribute, or create derivative
              works without our express written permission.
            </p>

            <h4>8. Prohibited Conduct</h4>
            <p>You agree not to:</p>
            <ul>
              <li>Use the Service for any unlawful purpose</li>
              <li>Scrape, crawl, or extract data from the Service in bulk</li>
              <li>Reverse-engineer or attempt to extract our underlying algorithms</li>
              <li>Resell or redistribute signals or data from the Service without authorization</li>
              <li>Interfere with or disrupt the Service or its infrastructure</li>
            </ul>

            <h4>9. Disclaimer of Warranties</h4>
            <p>
              The Service is provided "as is" and "as available" without warranties of any kind,
              express or implied, including but not limited to merchantability, fitness for a
              particular purpose, or accuracy of data. We do not guarantee that the Service will
              be uninterrupted or error-free.
            </p>

            <h4>10. Limitation of Liability</h4>
            <p>
              To the fullest extent permitted by law, DejaChart shall not be liable for any
              indirect, incidental, special, consequential, or punitive damages, including loss of
              profits or trading losses, arising from your use of or reliance on the Service.
              Our total liability to you shall not exceed the amounts paid by you to us in the
              twelve months preceding the claim.
            </p>

            <h4>11. Indemnification</h4>
            <p>
              You agree to indemnify and hold harmless DejaChart and its officers, directors,
              employees, and agents from any claims, liabilities, or expenses arising from your
              use of the Service or violation of these Terms.
            </p>

            <h4>12. Governing Law</h4>
            <p>
              These Terms are governed by the laws of the State of Delaware, without regard to
              conflict of law principles. Any disputes shall be resolved exclusively in the state
              or federal courts located in Delaware.
            </p>

            <h4>13. Contact</h4>
            <p>
              Questions about these Terms? Contact us at{" "}
              <a href="mailto:legal@dejachart.com">legal@dejachart.com</a>.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
